import { Dispatch, SetStateAction } from "react";
import { IComponentModal } from "../../../Modais/IModalComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faFileExcel,
    faFileUpload,
} from "@fortawesome/free-solid-svg-icons";
import ModalComponent from "../../../Modais";
import "./styles.css";
import UnForm from "../../../Form";
import {
    IAtendimentoCliente,
    TModoGestaoAtendimento,
} from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import IconOrSpinner from "../../../Utils/IconOrSpinner";

interface IAAlterarDadosComExcel {
    atendimento: TModoGestaoAtendimento;
    AlterarDadosExcelLoading: boolean;
    handleAlterarDadosExcel(filePath: File): void;
    updateAtendimentos: (...args: any[]) => Promise<{
        ATENDIMENTOS: IAtendimentoCliente[];
        PAGINAS: 0;
    }>;

    controller: () => Promise<any>;
    LeituraUpdateExcel: () => Promise<void>;
    filter?: any;
    leituraUpdateExcelLoading: boolean;

    setShow: Dispatch<SetStateAction<boolean>>;
    show: boolean;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    modal: IComponentModal | undefined;
}

export default function AlterarDadosComExcel(props: IAAlterarDadosComExcel) {
    let templateExcelValue: File;

    function AlterarDadosExcelComponent(title: string) {
        return (
            <div className="w-100 p-3">
                <div className="w-100 d-flex justify-content-between align-itens-center modal-title h3 ">
                    <div className="d-flex justify-content-center align-itens-center mt-1">
                        <FontAwesomeIcon
                            icon={faFileExcel}
                            className="mr-2 mt-1 d-flex justify-content-center align-itens-center"
                        />
                        <span className="card-label font-weight-bolder">
                            {title}
                        </span>
                    </div>
                    <div className="d-flex align-itens-end">
                        <button
                            className="btn btn-primary d-flex align-items-center justify-content-center"
                            onClick={props.LeituraUpdateExcel}
                            disabled={props.leituraUpdateExcelLoading}
                        >
                            <IconOrSpinner
                                icon={faDownload}
                                loading={props.leituraUpdateExcelLoading}
                                loadingSize="sm"
                            />
                            <span className="pl-2">Template Padrão</span>
                        </button>
                    </div>
                </div>
                <hr />
                <UnForm
                    handleSubmit={() =>
                        props.handleAlterarDadosExcel(templateExcelValue)
                    }
                >
                    <div className="d-flex justify-content-center align-items-center col-12 pt-5">
                        <div className="col-md-7">
                            <UnForm.Input
                                name="templatePadrao"
                                type="file"
                                onChange={(e) => {
                                    if (e.target.files) {
                                        templateExcelValue =
                                            e.target.files?.[0];
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-5">
                            <UnForm.SubmitButton
                                color="success"
                                loading={props.AlterarDadosExcelLoading}
                                disabled={props.AlterarDadosExcelLoading}
                                icon={faFileUpload}
                                className="w-100"
                            >
                                Enviar
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </UnForm>
            </div>
        );
    }

    return (
        <>
            <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 stickyMarginUploadExcel">
                <li
                    className="nav-item"
                    data-toggle="tooltip"
                    title="Upload Excel"
                    data-placement="left"
                    data-original-title="Alterar Dados"
                >
                    <button
                        className="btn btn-sm btn-icon btn-bg-light btn-icon-info btn-hover-success"
                        onClick={() => {
                            props.setShow(true);
                            props.setModal({
                                customHeader: AlterarDadosExcelComponent(
                                    "Alterar Dados Com Excel"
                                ),
                                size: "lg",
                                noFooter: true,
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faFileUpload} />
                    </button>
                </li>
            </ul>

            <ModalComponent
                show={props.show}
                setShow={props.setShow}
                ModalComponent={props.modal}
            />
        </>
    );
}
